import React from "react";
import "./style.scss";
import ZaufanieRadom from "./hooksZaufanie/radomJump";
import ZaufanieWarszawa from "./hooksZaufanie/warszawaJump";
import useConfirmationData from "./useConfirmationData";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import { HiOutlineDownload, HiOutlineTicket } from "react-icons/hi";
import EAButton from "../shared/Buttons/EAButton";
import EAAlert from "../shared/EAAlert";
import EASkeletonLoader from "../shared/EASkeletonLoader";
import { getAndClearB2bHomePageUrl } from "../../../utils/b2bHomePageStorage";

const PurchaseSuccess: React.FC = () => {
  const {
    loading,
    hasBillKey,
    confirmationData,
    getConfirmationDocument,
    getConfirmationTickets,
    facilityIds,
  } = useConfirmationData();
  const { t } = useTranslation();
  const startPageUrl = useSelector((state: State) => state.config.configuration.startPageUrl);
  const messageSummary = useSelector((state: State) => state.config.configuration.message_summary);

  const handleClickStartAgain = () => {
    const b2bHomePage = getAndClearB2bHomePageUrl();
    if (b2bHomePage) {
      window.open(`${window.location.origin}${b2bHomePage}`, "_parent");
    } else {
      window.open(startPageUrl, "_parent");
    }
  };

  if (loading) {
    return <EASkeletonLoader height="400px" />;
  }

  return (
    <div className="purchase-success__container">
      <h1>{t("platnosc_przebiegla_pomyslnie")}</h1>
      <p>{t("twoje_bilety_powinny_pojawic_sie_wkrotce_na_adresie_email")}</p>
      {messageSummary && messageSummary.length > 12 && (
        <EAAlert message={messageSummary} type="warning" dangerouslySetInnerHTML />
      )}

      {hasBillKey && (
        <div className="purchase-success__buttons">
          {confirmationData.containsTickets && (
            <EAButton
              title={`${t("pobierz_bilety")} (PDF)`}
              onClick={() => getConfirmationTickets()}
              endIcon={<HiOutlineTicket />}
            />
          )}
          {confirmationData.containsInvoice && (
            <EAButton
              title={t("pobierz_potwierdzenie")}
              onClick={() => getConfirmationDocument()}
              endIcon={<HiOutlineDownload />}
              variant="outlined"
            />
          )}
        </div>
      )}

      <EAButton title={t("zacznij_zakupy_od_nowa")} onClick={() => handleClickStartAgain()} variant="text" />

      {facilityIds === "1200" && (
        <>
          <ZaufanieRadom />
        </>
      )}
      {facilityIds === "1204" && (
        <>
          <ZaufanieWarszawa />
        </>
      )}
    </div>
  );
};

export default PurchaseSuccess;
